module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'selectDrug' || _vm.stage === 'selectLowStock' || _vm.stage === 'refill' || _vm.stage === 'DrugStorageInOneMed') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('ScanBarcode', {
    staticStyle: {
      "flex-direction": "column"
    },
    on: {
      "setBarcode": _vm.getBarcode
    }
  }, [_c('div', {
    staticClass: "with-child-centered"
  }, [(_vm.stage === 'selectDrug') ? _c('h2', [_vm._v("[ 手動藥倉補藥 ]")]) : _vm._e(), (_vm.stage === 'selectLowStock') ? _c('h2', [_vm._v("[ 存量過低藥物 ]")]) : _vm._e(), (_vm.stage === 'refill') ? _c('h2', [_vm._v("[ 藥倉補藥規劃 ]")]) : _vm._e(), (_vm.stage === 'DrugStorageInOneMed') ? _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("請選擇待補藥盒或補藥至新藥盒")])]) : _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("請掃描藥盒(身)條碼進行補藥")]), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("或於右方選擇待補藥物種類")])])])])], 1), _c('div', {
    staticClass: "col-6"
  }, [(_vm.stage === 'selectDrug') ? _c('drugList', {
    attrs: {
      "viewMode": 'medList',
      "medSelectMode": 'selectDrugStorage',
      "drugItemHeadWidth": '500px'
    },
    on: {
      "setDrugStorageWithSameMed": _vm.getDrugStorageWithSameMed
    }
  }) : _vm._e(), (_vm.stage === 'selectLowStock') ? _c('drugList', {
    attrs: {
      "mode": 'lowStock',
      "viewMode": 'medList',
      "medSelectMode": 'selectDrugStorage'
    },
    on: {
      "setDrugStorageWithSameMed": _vm.getDrugStorageWithSameMed
    }
  }) : _vm._e(), (_vm.stage === 'refill') ? _c('drugList', {
    attrs: {
      "mode": 'refill',
      "viewMode": 'medList',
      "medSelectMode": 'selectDrugStorage'
    },
    on: {
      "setDrugStorageWithSameMed": _vm.getDrugStorageWithSameMed
    }
  }) : _vm._e(), (_vm.stage === 'DrugStorageInOneMed') ? _c('drugList', {
    attrs: {
      "showRefillToNewDrugStorage": true
    },
    on: {
      "setNewDeviceForRefill": _vm.getNewDeviceForRefill
    }
  }) : _vm._e()], 1)]) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "startType": _vm.startType,
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), _c('action-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 'selectDrug'),
      expression: "currentStep === 'selectDrug'"
    }],
    attrs: {
      "slot": "button-3",
      "title": "手動補藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeStage('selectDrug')
      }
    },
    slot: "button-3"
  }), _c('action-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 'selectDrug'),
      expression: "currentStep === 'selectDrug'"
    }],
    attrs: {
      "slot": "button-4",
      "title": "存量過低"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeStage('selectLowStock')
      }
    },
    slot: "button-4"
  }), _c('action-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 'selectDrug'),
      expression: "currentStep === 'selectDrug'"
    }],
    attrs: {
      "slot": "button-5",
      "title": "補藥規劃"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeStage('refill')
      }
    },
    slot: "button-5"
  }), (_vm.currentStep === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "選擇全部"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAll($event)
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.currentStep === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "取消選擇"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deselectAll($event)
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始補充"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1), (_vm.showRefillSelection) ? _c('RefillSelection', {
    attrs: {
      "drugStorageIds": _vm.drugStorageIdsForSelected
    },
    on: {
      "selectionDone": _vm.selectionDone,
      "cancelSelection": _vm.cancelSelection
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97663418","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RefillDrug.vue
// module id = 1527
// module chunks = 1